import React, { useEffect } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Cookies from "js-cookie";
import Dashboard from "./components/Dashboard/Dashboard";
import Login from "./components/Login/Login";
import Users from "./components/Users/User";
import Support from "./components/Support/Support";
import ForgotPassword from "./components/ResetPassword/ForgotPassword";
import ResetPassword from "./components/ResetPassword/ResetPassword";
import NewAlertsPage from "./components/Alerts/NewAlertsPage";
import Unauthorized from "./components/Notifications/404/Unauthorized";
import AddAlert from "./components/AddAlert/AddAlert";
import Footer from "./components/Footer/Footer";
import useTokenExpiry from "./customhooks/useTokenExpiry";
import ErrorBoundary from "./common/ErrorBoundary/ErrorBoundary";

// Private Route Component
const PrivateRoute = ({ children }) => {
  const token = localStorage.getItem("token");
  return token ? children : <Navigate to="/" />;
};

function App() {
  const tokenExpiryModal = useTokenExpiry();

  const clearCacheData = () => {
    caches.keys().then((names) => {
      names.forEach((name) => {
        caches.delete(name);
      });
    });
  };

  const recordUserActivity = () => {
    const myCookieValue = Cookies.get("name");
    console.log("My Cookie Value:", myCookieValue);
  };

  useEffect(() => {
    clearCacheData();
    recordUserActivity();
  }, []);

  return (
    <>
      {tokenExpiryModal}
      <ErrorBoundary>
        <Routes>
          {/* Public Route: Login */}
          <Route exact path="/" element={<Login />} />

          {/* Private Routes */}
          <Route
            exact
            path="/home"
            element={
              <PrivateRoute>
                <Dashboard />
              </PrivateRoute>
            }
          />
          <Route exact path="/forgotpassword" element={<ForgotPassword />} />
          <Route exact path="/resetpassword" element={<ResetPassword />} />
          <Route
            exact
            path="/users"
            element={
              <PrivateRoute>
                <Users />
              </PrivateRoute>
            }
          />
          <Route
            exact
            path="/alerts"
            element={
              <PrivateRoute>
                <NewAlertsPage />
              </PrivateRoute>
            }
          />
          <Route
            exact
            path="/support"
            element={
              <PrivateRoute>
                <Support />
              </PrivateRoute>
            }
          />
          <Route exact path="/unauthorized" element={<Unauthorized />} />
          <Route
            exact
            path="/addalert"
            element={
              <PrivateRoute>
                <AddAlert />
              </PrivateRoute>
            }
          />
        </Routes>
        <Footer />
      </ErrorBoundary>
    </>
  );
}

export default App;
